module.exports = __webpack_public_path__ + "img/光照.d5826dc4.gif";